import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  bottomList: [],  //底部其他入口,
  rightsList: [],   //会员权益,
  conditionList: [],  //升级条件栏
  deadline: '',     //该购买会员到期日期
  isup: null,        //是否关联了微信  0：已关联
  privBuyList: [],   //底部购买点击后的弹窗
  privLeft: '',      //到期文案显示
  privList: [],      //底部购买栏
  privUpV2List: [],     //显示的礼包（常旅客礼包/抢票礼包）
  viplevel: '',       //该会员目前等级
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/home/store/index.js